module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "sn.498bc8ba.png" + "?" + Date.now();